// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"31a3459e","181":"d5194898","311":"2a999bc0","453":"9d95fb98","484":"826df457","749":"5a0b484b"}[chunkId] + ".chunk.js";
};